/* Prime Raw — before/after comparison slider. Uses a native range input for keyboard + touch. */
if (!customElements.get('pr-compare')) {
  customElements.define(
    'pr-compare',
    class PrCompare extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.pr-compare__range');
        if (!this.input) return;
        var self = this;
        var set = function () { self.style.setProperty('--pr-pos', self.input.value + '%'); };
        this.input.addEventListener('input', set);
        this.input.addEventListener('pointerdown', function () { self.classList.add('is-dragging'); });
        window.addEventListener('pointerup', function () { self.classList.remove('is-dragging'); });
        set();
      }
    }
  );
}
